import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { loadAnnouncements as loadAnnouncementsFromApi } from '../../api';
import {
  LOADED_ANNOUNCEMENTS,
  LOADING_ANNOUNCEMENTS,
  AnnouncementCollectionViewModel,
} from './types';
import { AppState } from '../../store';

const loadingAnnouncementsStarted = () => {
  return {
    type: LOADING_ANNOUNCEMENTS,
  };
};

const loadAnnouncementsCompleted = (data: AnnouncementCollectionViewModel) => {
  return {
    type: LOADED_ANNOUNCEMENTS,
    payload: data,
  };
};

const loadAnnouncements = (
  token: string
): ThunkAction<void, AppState, null, Action<string>> => async (dispatch) => {
  dispatch(loadingAnnouncementsStarted());

  const response = await loadAnnouncementsFromApi(token);
  dispatch(loadAnnouncementsCompleted(response.data));
};

export { loadAnnouncements };
